/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

/**
 * Product reviews methods
 * -----------------------------------------------------------------------------
 *
 * @namespace productReviews
 */

import Flickity from 'flickity';
import axios from 'axios';
import Pagination from 'laravel-vue-pagination';
import StarRating from 'vue-star-rating';

// Import FilePond polyfill for IE11 support
import 'filepond-polyfill';

// Import Vue FilePond
import vueFilePond from 'vue-filepond';

// Import image preview and file type validation plugins
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileEncode from 'filepond-plugin-file-encode';

// Create component
var FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview, FilePondPluginFileEncode);

// global variables
var shopifyId = void 0;
var shopifyDomain = Shopify.shop;
var apiUrl = 'https://reviews.hulkapps.com/api/shop';
var $reviewsApp = $('[data-product-reviews]');
var productId = $reviewsApp.data('product-id');
var productTitle = $reviewsApp.data('product-title');
var reviewsType = $reviewsApp.data('type');

var productReviewsMethods = {
  components: {
    Pagination: Pagination,
    StarRating: StarRating,
    FilePond: FilePond
  },

  data: function data() {
    return {
      googleData: '',
      reviewSettings: {},
      productReviews: {
        data: {},
        pagination: {}
      },
      allReviews: {
        data: {},
        pagination: {}
      },
      singleReview: {},
      modalReviewsData: {},
      totalReviews: 0,
      reviewsAvgRating: 0,
      rating: 5,
      userReviewImage: {
        name: null,
        data: null
      }
    };
  },


  methods: {
    _initProductReviews: function _initProductReviews() {
      // if (!window.theme.productReviewsEnabled) {
      //   return;
      // }
      app._getShopReviews();
      app._checkUrlParams();
    },
    _checkUrlParams: function _checkUrlParams() {
      // check for URL parameter in order to open the new review modal
      var showReviewForm = app._getUrlParameter('showReviewForm');

      if (showReviewForm === 'true') {
        setTimeout(function () {
          app._showReviewForm();
        }, 1500);
      }
    },
    _scrollToReviews: function _scrollToReviews() {
      var $target = void 0;

      if (reviewsType === 'productReviews') {
        $target = $('[data-review-tab]');
      } else {
        $target = $('header');
      }

      $('html, body').animate({
        scrollTop: $target.offset().top - 30
      }, 10);
    },
    _createReviewsLd: function _createReviewsLd() {
      var script = document.createElement('script');
      script.type = 'application/ld+json';
      script.innerHTML = JSON.stringify(app.googleData, null, 4);
      document.getElementsByTagName('body')[0].appendChild(script);
    },
    _createNewProductLd: function _createNewProductLd(obj) {
      // remove old script
      $('#productLd').remove();
      var script = document.createElement('script');
      script.id = 'productLd';
      script.type = 'application/ld+json';
      script.innerHTML = JSON.stringify(obj, null, 4);
      document.getElementsByTagName('body')[0].appendChild(script);
    },
    _initReviewsCarousel: function _initReviewsCarousel() {
      new Flickity('[data-reviews-carousel]', {
        adaptiveHeight: true,
        accessibility: true,
        autoPlay: 5000,
        cellAlign: 'center',
        dragThreshold: 20,
        groupCells: '100%',
        prevNextButtons: true,
        pageDots: true,
        setGallerySize: true,
        wrapAround: false,
        contain: true,
        arrowShape: {
          x0: 10, x1: 60, y1: 50, x2: 60, y2: 45, x3: 15
        }
      });
    },
    _getShopReviews: function _getShopReviews() {
      // first find the Shop Id by providing the shopify domain
      axios.get(apiUrl + "?shopify_domain=" + shopifyDomain).then(function (response) {
        shopifyId = response.data.data.shopify_id;
        if (!shopifyId && shopifyId !== undefined) {
          return;
        }
        if (app.currentTemplate === 'product') {
          app._getReviews();
          app._getCollectionReviews();
        } else if (app.currentTemplate === 'collection') {
          app._getCollectionReviews();
        } else if (app.currentTemplate === 'search') {
          app._getCollectionReviews();
        } else if (app.currentTemplate === 'collections') {
          app._getCollectionReviews();
        } else if (app.currentTemplate === 'index') {
          app._getCollectionReviews();
        } else if (app.currentTemplate === 'page') {
          app._getCollectionReviews();
        }
        return response;
      }).catch(function (error) {
        console.log(error);
        throw error;
      });
    },
    _getProductReviews: function _getProductReviews() {
      return axios.get(apiUrl + "/" + shopifyId + "/reviews?product_id=" + productId);
    },
    _getSettings: function _getSettings() {
      return axios.get(apiUrl + "/" + shopifyId + "/settings");
    },
    _pushStructuredObj: function _pushStructuredObj(arr, review) {
      arr.push({
        '@context': 'http://schema.org/',
        '@type': 'Review',
        itemReviewed: {
          '@type': 'Product',
          name: productTitle,
          aggregateRating: {
            '@type': 'AggregateRating',
            ratingValue: app.reviewsAvgRating,
            reviewCount: app.totalReviews
          }
        },
        author: {
          '@type': 'Person',
          name: review.author
        },
        name: review.title,
        reviewBody: review.body,
        reviewRating: {
          '@type': 'Rating',
          ratingValue: review.rating,
          bestRating: '5'
        }
      });
    },
    _getReviews: function _getReviews() {
      // app.isLoading = true
      // axios multiple requests
      axios.all([app._getProductReviews(), app._getSettings()]).then(axios.spread(function (productReviewsRes, settingsRes) {
        // All requests are now complete
        var settings = settingsRes.data.data;
        var layoutMode = settings.layout_mode;
        var reviews = productReviewsRes.data;
        // set data
        app.reviewSettings = settings;
        app.productReviews.data = reviews.data;
        app.productReviews.pagination = reviews;
        app.totalReviews = reviews.total;
        app.reviewsAvgRating = Number(reviews.avg_rating).toFixed(1);
        app.$nextTick(function () {
          // app.isLoading = false
          $('[data-product-reviews]').fadeIn();

          if (app.productReviews && layoutMode === 'carousel') {
            app._initReviewsCarousel();
          }
        });
      })).catch(function (error) {
        // console.log(error);
        app.isLoading = false;
        throw error;
      });
    },


    // all reviews
    _getReviewsAll: function _getReviewsAll() {
      axios.get(apiUrl + "/" + shopifyId + "/settings").then(function (response) {
        // eslint-disable-next-line promise/always-return
        if (response.data.data.status) {
          app.reviewSettings = response.data.data;
          if (reviewsType === 'allReviews') {
            var reviewAPIEndPoint = apiUrl + "/" + shopifyId + "/reviews";
            // eslint-disable-next-line promise/catch-or-return
            // eslint-disable-next-line promise/no-nesting
            axios.get(reviewAPIEndPoint)
            // eslint-disable-next-line promise/always-return
            .then(function (response) {
              app.allReviews.data = response.data.data;
              app.allReviews.pagination = response.data;
              delete app.allReviews.pagination.data;
              app.totalReviews = response.data.total;
              app.$nextTick(function () {
                $('[data-product-reviews]').fadeIn();
              });
            });
          }
        }
      }).catch(function (error) {
        // console.log(error);
        app.isLoading = false;
        throw error;
      });
    },
    _getRating: function _getRating(review) {
      var self = this;
      var rating = '';

      for (var i = 0; i < 5; i += 1) {
        if (review.rating > i) {
          rating += "<span class=\"icon-review ion-ios-" + self.reviewSettings.rating_symbol + "\" style=\"color:" + self.reviewSettings.rating_color + "\"></span>";
        } else {
          rating += "<span class=\"icon-review ion-ios-" + self.reviewSettings.rating_symbol + "\" style=\"color:#808080\"></span>";
        }
      }
      return rating;
    },
    _getAvgRating: function _getAvgRating() {
      var self = this;
      var rating = '';
      for (var i = 0; i < 5; i += 1) {
        if (self.reviewsAvgRating > i) {
          rating += "<span class=\"icon-review ion-ios-" + self.reviewSettings.rating_symbol + "\" style=\"color:" + self.reviewSettings.rating_color + "\"></span>";
        } else {
          rating += "<span class=\"icon-review ion-ios-" + self.reviewSettings.rating_symbol + "\" style=\"color:#808080\"></span>";
        }
      }
      return rating;
    },
    _getPagedResults: function _getPagedResults(page) {
      var reviewsUrl = '';
      app.isLoading = true;
      if (typeof page === 'undefined') {
        page = 1;
      }

      if (reviewsType === 'productReviews') {
        reviewsUrl = "/" + shopifyId + "/reviews?product_id=" + productId + "&page=" + page;
      }

      if (reviewsType === 'allReviews') {
        reviewsUrl = "/" + shopifyId + "/reviews?page=" + page;
      }

      axios.get(apiUrl + reviewsUrl).then(function (response) {
        if (reviewsType === 'productReviews') {
          app.productReviews.data = response.data.data;
          app.productReviews.pagination = response.data;
          delete app.productReviews.pagination.data;
        }

        if (reviewsType === 'allReviews') {
          app.allReviews.data = response.data.data;
          app.allReviews.pagination = response.data;
          delete app.allReviews.pagination.data;
        }

        app.isLoading = false;
        app._scrollToReviews();
        return response;
      }).catch(function (error) {
        app.isLoading = false;
        throw error;
      });
    },
    _handleUserFileAdded: function _handleUserFileAdded() {
      var imageData = JSON.parse($('input[name="userReviewImage"').val());
      app.userReviewImage.name = imageData.name;
      app.userReviewImage.data = imageData.data;
    },
    _resetForm: function _resetForm() {
      app.rating = 5;
      if (app.reviewSettings.image_upload_enable) {
        this.$refs.userReviewImage.removeFiles();
        app.userReviewImage.name = null;
        app.userReviewImage.data = null;
      }
      $('#newReviewForm')[0].reset();
      $('#newReviewForm').find('input[type="submit"]').removeClass('disabled');
    },
    _showReviewForm: function _showReviewForm() {
      app._resetForm();
      $('#response').empty();
      $('[data-modal-new-review]').modal('show');
    },
    _showReviewSingle: function _showReviewSingle(reviews, reviewId) {
      $('[data-modal-single-review]').modal('show');
      app.modalReviewsData = reviews;
      var review = reviews.find(function (itemX) {
        return itemX.id === reviewId;
      });

      app.singleReview = review;
      app._checkPagination(reviews, app.singleReview.id);
    },
    _getPrevReview: function _getPrevReview(reviewId) {
      var reviews = app.modalReviewsData;
      var currentItemIndex = reviews.findIndex(function (itemK) {
        return itemK.id === reviewId;
      });

      if (currentItemIndex > 0) {
        app.singleReview = reviews[currentItemIndex - 1];
      }
      app._checkPagination(reviews, app.singleReview.id);
    },
    _getNextReview: function _getNextReview(reviewId) {
      var reviews = app.modalReviewsData;
      var currentItemIndex = reviews.findIndex(function (itemItem) {
        return itemItem.id === reviewId;
      });
      if (currentItemIndex < reviews.length - 1) {
        app.singleReview = reviews[currentItemIndex + 1];
      }
      app._checkPagination(reviews, app.singleReview.id);
    },
    _checkPagination: function _checkPagination(reviews, reviewId) {
      var currentItemIndex = reviews.findIndex(function (itemA) {
        return itemA.id === reviewId;
      });

      if (currentItemIndex === 0) {
        $('#prevLink').addClass('disabled');
      } else {
        $('#prevLink').removeClass('disabled');
      }
      if (currentItemIndex === reviews.length - 1) {
        $('#nextLink').addClass('disabled');
      } else {
        $('#nextLink').removeClass('disabled');
      }
    },
    _createReview: function _createReview() {
      var successHtml = '';
      var errorsHtml = '';
      var $newReviewForm = $('#newReviewForm');
      var settings = app.reviewSettings;

      var customFields = $("input[name='custom_field[]']").map(function () {
        return {
          id: $(this).attr('data-id'),
          value: $(this).val()
        };
      }).get();

      var formData = {
        shopify_id: shopifyId,
        product_id: productId,
        product_handle: $newReviewForm.find('input[name=productHandle]').val(),
        product_title: $newReviewForm.find('input[name=productTitle]').val(),
        product_image: $newReviewForm.find('input[name=productImage]').val(),
        author: $newReviewForm.find('input[name=author]').val(),
        email: $newReviewForm.find('input[name=email]').val(),
        title: $newReviewForm.find('input[name=title]').val(),
        body: $newReviewForm.find('textarea[name=body]').val(),
        rating: app.rating,
        custom_fields: customFields,
        image_name: app.userReviewImage.name,
        image_data: app.userReviewImage.data
      };

      // console.log(JSON.stringify(formData));

      $newReviewForm.find('input[type="submit"]').addClass('disabled').val('Please Wait');

      axios.post(apiUrl + "/" + shopifyId + "/reviews", formData).then(function (response) {
        var message = void 0;

        if (settings.auto_publish_star && formData.rating >= settings.auto_publish_star) {
          message = 'Review has been successfully submitted. Thank you!';
          app._getReviews();
        } else {
          message = 'Review has been successfully submitted and awaiting for approval. Thank you!';
        }

        $('#newReviewForm').find('input[type="submit"]').val('Submit');
        successHtml = "<div class=\"alert alert-success\">" + message + "</div>";
        $('#response').html(successHtml);

        app._resetForm();

        setTimeout(function () {
          $('[data-modal-new-review]').modal('hide');
        }, 5000);

        return response;
      }).catch(function (error) {
        $('#newReviewForm').find('input[type="submit"]').removeClass('disabled').val('Submit');
        var errors = error.response.data.message;
        errorsHtml = '<div class="alert alert-warning"><ul>';
        $.each(errors, function (key, value) {
          errorsHtml += "<li>" + value[0] + "</li>";
        });
        errorsHtml += '</ul></div>';
        $('#response').html(errorsHtml);
        throw error;
      });
    },


    // reviews for collection => product grid item
    _getCollectionReviews: function _getCollectionReviews() {
      var product_id = void 0;
      var ids = void 0;
      if (shopifyId !== undefined) {
        axios.get(apiUrl + "/" + shopifyId + "/settings").then(function (response) {
          // eslint-disable-next-line promise/always-return
          if (response.data.data.status) {
            app.reviewSettings.rating_symbol = response.data.data.rating_symbol;
            app.reviewSettings.symbol_color = response.data.data.rating_color;
          }
        }).catch(function (error) {
          // console.log(error);
          app.isLoading = false;
          throw error;
        });
        setTimeout(function () {
          $('[data-item-reviews]').each(function (i) {
            // eslint-disable-next-line eqeqeq
            if (i == 0) {
              product_id = $(this).attr('data-product-id');
            } else {
              product_id = product_id + "," + $(this).attr('data-product-id');
            }
            ids = product_id;
          });

          if (ids != undefined) {
            axios.get(apiUrl + "/" + shopifyId + "/reviews/ratings?product_ids=" + ids).then(function (response) {
              app.allReviews = response.data.data;
              app._setProductCardReviews();
              return response;
            }).catch(function (error) {
              // console.log(error);
              throw error;
            });
          }
        }, 600);
      }
    },
    _setProductCardReviews: function _setProductCardReviews() {
      setTimeout(function () {
        $('body').find('[data-item-reviews]').each(function () {
          var productId = $(this).attr('data-product-id');
          var productLink = $(this).attr('data-product-href');
          var itemReviews = app.allReviews.filter(function (itemP) {
            return itemP.product_id === productId;
          });
          var ratingHtml = '';
          var itemHtml = '';
          if (itemReviews.length < 1) {
            for (var i = 0; i < 5; i += 1) {
              ratingHtml += "<span class=\"icon-review ion-ios-" + app.reviewSettings.rating_symbol + "\" style=\"color:#808080\"></span>";
            }
            itemHtml = "<a href=\"" + productLink + "?reviews\" class=\"font-weight-bold\" style=\"color:#ffc700;\">" + ratingHtml + "</a>";
            $(this).html(itemHtml);
            return;
          }

          var totalReviews = itemReviews[0].total_reviews;
          var avgRating = Math.round(itemReviews[0].avg_rating);
          for (var _i = 0; _i < 5; _i += 1) {
            if (avgRating > _i) {
              ratingHtml += "<span class=\"icon-review ion-ios-" + app.reviewSettings.rating_symbol + "\" style=\"color:" + app.reviewSettings.symbol_color + "\"></span>";
            } else {
              ratingHtml += "<span class=\"icon-review ion-ios-" + app.reviewSettings.rating_symbol + "\" style=\"color:#808080\"></span>";
            }
          }

          if (totalReviews) {
            var text = '';
            if (totalReviews > 1) {
              text = 'reviews';
            } else {
              text = 'review';
            }
            itemHtml = "<a href=\"" + productLink + "?reviews\" class=\"font-weight-bold\" style=\"color:#ffc700;\">" + ratingHtml + "</a>";
          }

          $(this).html(itemHtml);
          // dispatch event for the vue match heights directive/plugin
          document.dispatchEvent(new Event('matchheight'));
        });
      }, 600);
    }
  }
};
export default productReviewsMethods;